/**
 * Time utilities
 */

/**
 * Format time in mm:ss format
 * @param seconds - Time in seconds
 * @returns Formatted time string (e.g., "02:35")
 */
export function formatTime(seconds: number): string {
  if (!seconds || isNaN(seconds)) return '00:00';
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
}

/**
 * Parse time string (mm:ss) to seconds
 * @param timeStr - Time string in mm:ss format
 * @returns Time in seconds
 */
export function parseTime(timeStr: string): number {
  if (!timeStr) return 0;
  const parts = timeStr.split(':');
  if (parts.length === 2) {
    const minutes = parseInt(parts[0] ?? '0', 10) || 0;
    const seconds = parseInt(parts[1] ?? '0', 10) || 0;
    return minutes * 60 + seconds;
  }
  return 0;
}

/**
 * Format duration in human-readable format (e.g., "2 min 30 sec")
 * @param seconds - Duration in seconds
 * @returns Human-readable duration string
 */
export function formatDuration(seconds: number): string {
  if (!seconds || isNaN(seconds)) return '0 sec';
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  if (minutes === 0) {
    return `${remainingSeconds} sec`;
  } else if (remainingSeconds === 0) {
    return `${minutes} min`;
  } else {
    return `${minutes} min ${remainingSeconds} sec`;
  }
}

export default {
  formatTime,
  parseTime,
  formatDuration
};
